import styled from 'styled-components'
import { mediaQueries } from '../../constants/mediaQueries'

export const MonthlyPeakGainsWrapper = styled.div`
    display: block;
    width: 100%;
    margin-left: -25px;
`